/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-01 21:58:48
 * @Last Modified by: Josselin Hubert
 * @Last Modified time: 2020-09-02 17:46:18
 */

<template>
  <v-app-bar v-scroll="onScroll"
             :color="color"
             :dark="!hasColor"
             :light="hasColor"
             app
             elevate-on-scroll>
    <!-- <v-app-bar-nav-icon class="hidden-md-and-up"
                        @click="toggleDrawer" />

    <v-spacer class="hidden-sm-and-up" /> -->

    <v-toolbar-title class="headline">
      <template v-if="$vuetify.breakpoint.smAndUp">
        <span class="font-weight-bold">
          {{$t('appName')}}
        </span>
        <span class="font-weight-light ml-2">
          LLC
        </span>
      </template>
      <!-- <span v-else
            class="font-weight-bold">
        LANDING
      </span> -->
    </v-toolbar-title>

    <v-spacer class="hidden-xs-only" />

    <!-- home -->
    <v-btn class="font-weight-light hidden-sm-and-down ml-2"
           large
           text
           to="/"
           @click="scrollTopIfHome()">
      <!-- to="/" -->
      {{ $t('navigation.home') }}
    </v-btn>

    <!-- skills -->
    <v-btn class="font-weight-light hidden-sm-and-down mx-2"
           large
           text
           to="/skills">
      {{ $t('navigation.skills') }}
    </v-btn>

    <!-- Select Language -->
    <v-menu bottom
            offset-y
            left
            v-if="!hasColor">

      <template v-slot:activator="{ on }">
        <v-btn icon
               v-on="on">
          <v-icon v-if="language === undefined"
                  x-large
                  light>fa-flag</v-icon>
          <img v-else
               :src="language.flag"
               width="36"
               height="36">
        </v-btn>
      </template>

      <v-list>
        <template v-for="(item, index) in languages">

          <v-list-item :key="index"
                       @click="selectLanguage(item.code)">
            <v-list-item-icon>
              <img :src="item.flag">
            </v-list-item-icon>
            <v-list-item-title>
              <v-list-item-title>{{item.text}}</v-list-item-title>
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  // Utilities
  //import { mapMutations, mapState } from "vuex";

  export default {
    name: "CoreAppBar",

    /******************************************
     *                Components              *
     ******************************************/
    components: {},

    /******************************************
     *                 Computed               *
     ******************************************/
    computed: {
      // ...mapState("app", ["links"]),
      color() {
        return this.hasColor ? "white" : "transparent";
      },
    },

    /******************************************
     *                   Data                 *
     ******************************************/
    data: () => ({
      hasColor: false,

      language: {},
      languages: [
        {
          flag: "https://www.countryflags.io/us/flat/48.png",
          text: "English",
          code: "en",
        },
        {
          flag: "https://www.countryflags.io/fr/flat/48.png",
          text: "Français",
          code: "fr",
        },
      ],
    }),

    /******************************************
     *                 Methods                *
     ******************************************/
    methods: {
      //...mapMutations("app", ["toggleDrawer"]),
      onScroll() {
        this.hasColor = window.scrollY > 50;
      },

      /**
       * Navigate Home
       */
      scrollTopIfHome() {
        console.log("router path: ", this.$router.currentRoute.path);

        if (this.$router.currentRoute.path === "/") {
          this.$vuetify.goTo("#hero", {
            duration: 500,
            easing: "easeInOutCubic",
            offset: 0,
          });
        } else {
          //this.$router.push("\\");
        }
      },

      /**
       * Define a new language
       */
      selectLanguage(lang) {
        this.languages.forEach((element) => {
          if (element.code === lang) {
            this.language = element;
            // this.$store.dispatch("language", this.language.code);
            // this.$store.commit("language", this.language.code);
            this.$store.commit("app/language", this.language.code);
            this.$i18n.locale = this.language.code;
            return;
          }
        });
      },
    },

    /******************************************
     *                 Events                 *
     ******************************************/
    created() {
      var lang = this.$store.state.app.language;
      if (!lang) {
        lang = window.navigator.language.substr(0, 2) === "fr" ? "fr" : "en";
      }

      this.selectLanguage(lang);
    },
  };
</script>
